<template>
  <span>
    <a v-b-modal.login-modal class="nav-link d-flex align-items-center text-dark font-weight-bold">
      <i class="fa fa-user-circle fa-2x mr-2"></i> Sign In
    </a>
    <b-modal id="login-modal" size="xl" hide-header hide-footer>
      <template v-slot:default="{ close }">
        <div class="row p-0">
          <div class="col-lg-7 bg-sign-in-modal d-flex justify-content-center">
            <div class="mt-5">
              <h1 class="d-none d-sm-block d-md-block">Sign in to take the test</h1>
              <h3 class="d-block d-sm-none">Sign in to take the test</h3>
              <p class="mb-5">
                By signing in you will able to view your
                dashboard as well.
              </p>
              <img class="mobile-hidden" src="media/sign-in-modal-img.svg" />
            </div>
          </div>
          <div class="col-lg-5">
            <div class="mb-4">
              <button type="button" class="close p-0" @click="close()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form class="px-4 py-4" @submit.stop.prevent="submit" novalidate>
              <div class="form-group">
                <label for="mykad">Email</label>
                <input
                  v-model="auth.email"
                  type="email"
                  class="form-control bg-gray border-0"
                  id="mykad"
                />
              </div>
              <div class="form-group">
                <label for="password">Password</label>
                <input
                  v-model="auth.password"
                  type="password"
                  class="form-control bg-gray border-0"
                  id="password"
                />
                <span toggle="#password" class="las la-eye input-icon toggle-password"></span>
              </div>
              <div class="mt-4">
                <button type="submit" class="btn btn-block btn-primary py-3">Sign In</button>
              </div>
              <!-- <div class="mt-5 mb-3">
                <p class="or">
                  <span>OR</span>
                </p>
              </div>
              <div class="mt-4">
                <button class="btn btn-block py-3 btn-facebook text-white">
                  <i class="fab fa-facebook-f fa-lg mr-5"></i>Sign in with Facebook
                </button>
              </div>
              <div class="mt-3">
                <button class="btn btn-block py-3 btn-google text-white">
                  <i class="fab fa-google fa-lg mr-5"></i>Sign
                  in with Google
                </button>
              </div>-->
              <div class="mt-5 d-flex justify-content-center">
                <p class="text-dark">
                  Don't have an account yet?
                  <a :href="route('en.register')">
                    <span class="text-primary ml-2 font-weight-bold">Sign up</span>
                  </a>
                </p>
              </div>
            </form>
          </div>
        </div>
      </template>
    </b-modal>
  </span>
</template>

<script>
export default {
  data() {
    return this.initialState();
  },
  mounted() {
    console.log("Component mounted.");
  },
  methods: {
    initialState() {
      return {
        auth: {
          email: null,
          password: null
        }
      };
    },
    async submit() {}
  }
};
</script>
